import { IAnnotation } from "../../model/DutyStatusLog";
import { ActionsUnion, createAction } from "../definitions";
import { HOSAnnotationActionTypes } from "./types";

export interface IHosAnnotationPayload {
    userId: string;
    annotations: IIdDictionary<IAnnotation>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const HosAnnotationActions = {
    setAnnotations: (payload: IHosAnnotationPayload) => createAction(HOSAnnotationActionTypes.SET_ANNOTATIONS, payload),
    clearAnnotations: (userId: string) => createAction(HOSAnnotationActionTypes.CLEAR_ANNOTATIONS, userId)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HosAnnotationActions = ActionsUnion<typeof HosAnnotationActions>;